import { render } from "./precautions.vue?vue&type=template&id=2d428cc9&scoped=true"
import script from "./precautions.vue?vue&type=script&lang=js"
export * from "./precautions.vue?vue&type=script&lang=js"

import "./precautions.vue?vue&type=style&index=0&id=2d428cc9&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d428cc9"]])

export default __exports__